import { getLanguage } from "swiipe.portal.shared"

interface ISupportLinkLanguages {
    [languageCode: string]: ISupportLinkConfig
}

interface ISupportLinkConfig {
    returnSell: {
        guide: string
    }
}

export const zendeskBaseUrl = "https://aera-ecom-support.zendesk.com"

const supportLinks: ISupportLinkLanguages = {
    en: {
        returnSell: {
            guide: `${zendeskBaseUrl}/hc/da/sections/16962854427025-Return-sell`,
        },
    },
    da: {
        returnSell: {
            guide: `${zendeskBaseUrl}/hc/da/sections/16962854427025-Return-sell`,
        },
    },
}

export const getSupportLink = (selector: (config: ISupportLinkConfig) => string | undefined): string => {
    const language = getLanguage()
    if (supportLinks[language]) {
        const currentLanguageValue = selector(supportLinks[language])
        if (currentLanguageValue) {
            return currentLanguageValue
        }
    }

    const enValue = selector(supportLinks["en"])
    if (enValue) {
        return enValue
    }

    const daValue = selector(supportLinks["da"])
    if (daValue) {
        return daValue
    }

    return ""
}
